import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { Flex, Spinner, Text } from '@chakra-ui/react';

// mode: 'require-profile' => usado para /admin (perfil obrigatório)
// mode: 'new-user-only' => usado para /auth/new-user (apenas se ainda não tiver perfil)
export default function RequireUserProfile({ children, mode = 'require-profile' }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        console.debug('RequireProfile:onAuthStateChanged user=', user);

        if (!user) {
          console.debug('RequireProfile: no user -> redirect to sign-in');
          if (isMounted) setLoading(false);
          navigate('/auth/sign-in/default', { replace: true });
          return;
        }

        const profileRef = doc(db, 'users', user.uid);
        const profileSnap = await getDoc(profileRef);
        const profile = profileSnap.exists() ? profileSnap.data() : null;
        console.debug('RequireProfile: profile=', profile);

        const VALID_ROLES = ['tecnico', 'supervisor', 'admin', 'cliente'];

        if (mode === 'require-profile') {
          if (!profile || !VALID_ROLES.includes(profile.role)) {
            console.debug('RequireProfile: role ausente ou inválido -> redirect to new-user');
            navigate('/auth/new-user', { replace: true });
          } else if (isMounted) {
            setLoading(false);
          }
        }

        if (mode === 'new-user-only') {
          if (profile?.role) {
            navigate('/admin', { replace: true });
          } else if (isMounted) {
            setLoading(false);
          }
        }
      } catch (error) {
        console.error('RequireProfile: erro ao validar sessão/perfil', error);
        if (isMounted) setLoading(false);
        navigate('/auth/sign-in/default', { replace: true });
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [mode, navigate]);

  if (loading)
    return (
      <Flex align="center" justify="center" minH="40vh">
        <Spinner size="lg" color="brand.500" />
        <Text ms={3}>Carregando perfil...</Text>
      </Flex>
    );

  return children;
}
